<div [class]="skinName">
  <div id="ideal-bank-element" #idealBankElement></div>
  @if (idealEmptyError && proceedPayment) {
    <p class="help-block">{{ configService.localeKeys?.pay_stripe_err_select_bank}}</p>
  }
  <button class="blue-btn pay-button" (click)="payment($event)">{{ configService.localeKeys?.['plans.proceed.text'] }}</button>

</div>